<div>
  <mat-drawer-container style="background:white;" class="normalScreen">
    <mat-drawer #drawer class="sidenav" opened="true" mode="side">
      <mat-accordion displayMode="flat" multi="true" style="display:block">
        <mat-expansion-panel class="mat-elevation-z0"  [expanded]="selectedItem <= 6">
          <mat-expansion-panel-header class="header" data-cy="reportsDropDown">
            <mat-panel-title style="align-content:center">
              <mat-icon>list_alt</mat-icon>
              <label style="margin-left:10px">Rapporter</label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list data-cy="reportsOption">
            <a mat-list-item data-cy="invoices" [ngStyle]="itemStyle(1)" (click)="itemSelected(1)">Faktureringsunderlag</a>
            <a mat-list-item data-cy="flight" [ngStyle]="itemStyle(2)" (click)="itemSelected(2)">Flygrapport</a>
            <a mat-list-item data-cy="transfer" [ngStyle]="itemStyle(3)" (click)="itemSelected(3)">Transferrapport</a>
            <a mat-list-item data-cy="transferSummary" [ngStyle]="itemStyle(4)" (click)="itemSelected(4)">Transfersummering</a>
            <a mat-list-item data-cy="historical" [ngStyle]="itemStyle(5)" (click)="itemSelected(5)">Förarrapport</a>
            <a mat-list-item data-cy="checkin" [ngStyle]="itemStyle(6)" (click)="itemSelected(6)">Incheckningar</a>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="selectedItem > 6">
          <mat-expansion-panel-header class="header" data-cy="statsDropDown">
            <mat-panel-title style="align-content:center">
              <mat-icon>bar_chart</mat-icon>
              <label style="margin-left:10px">Statistik</label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-nav-list data-cy="historyReport">
            <a mat-list-item [ngStyle]="itemStyle(7)" (click)="itemSelected(7)">Historisk rapport</a>
          </mat-nav-list>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-drawer>

    <div class="sidenav-content" data-cy="historySum">
      <invoices *ngIf="selectedItem == 1" #invoices></invoices>
      <flight *ngIf="selectedItem == 2" #flight></flight>
      <transfer *ngIf="selectedItem == 3" #transfer></transfer>
      <transferSummary *ngIf="selectedItem == 4" #transferSummary></transferSummary>
      <driver *ngIf="selectedItem == 5" #driver></driver>
      <checkIn-report *ngIf="selectedItem == 6" #checkin></checkIn-report>
      <historical *ngIf="selectedItem == 7" #historical></historical>

    </div>

  </mat-drawer-container>


</div>
